/**
 * Extract a user-facing message from an API error.
 *
 * The axios interceptor in `api-base/instance.ts` unwraps BE responses
 * into `{ status, message }`, and call sites also `throw new Error(res.data.message)`
 * on `success: false`. Both cases land on `err.message`.
 */
/** BE error code (`data.error`, e.g. PTO_POOL_STILL_OPEN) as forwarded by the axios interceptor */
export const getApiErrorCode = (err: unknown): string | undefined => {
  if (err && typeof err === 'object') {
    const anyErr = err as {
      error?: unknown
      data?: { error?: unknown }
      response?: { data?: { error?: unknown } }
    }
    const code = anyErr.error ?? anyErr.data?.error ?? anyErr.response?.data?.error
    return typeof code === 'string' ? code : undefined
  }
  return undefined
}

export const getApiErrorMessage = (err: unknown, fallback: string): string => {
  if (err && typeof err === 'object') {
    const anyErr = err as { response?: { data?: { message?: string } }; message?: string }
    return (
      anyErr.response?.data?.message ||
      (typeof anyErr.message === 'string' && anyErr.message) ||
      fallback
    )
  }
  return fallback
}
